import axiosInstance from "../../interceptor";
import Toaster from "../../../Shared/Toaster";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllPatients = createAsyncThunk(
  "getAllPatients",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getAllPatientVisits = createAsyncThunk(
  "getAllPatientVisits",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const createPatientVisit = createAsyncThunk(
  "createPatientVisit",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const createPatient = createAsyncThunk(
  "createPatient",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getAllTreatmentCodes = createAsyncThunk(
  "getAllTreatmentCodes",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getAllTreatmentActivities = createAsyncThunk(
  "getAllTreatmentActivities",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const createVisitRecord = createAsyncThunk(
  "createVisitRecord",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const updateVisitRecord = createAsyncThunk(
  "updateVisitRecord",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const confirmSummary = createAsyncThunk(
  "confirmSummary",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const sendPatientNotification = createAsyncThunk(
  "sendPatientNotification",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const addTreatmentActivity = createAsyncThunk(
  "addTreatmentActivity",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getVisitRecords = createAsyncThunk(
  "getVisitRecords",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getAiReport = createAsyncThunk(
  "getAiReport",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message || error?.response?.data?.details);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const deleteTreatment = createAsyncThunk(
  "deleteTreatment",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(apiEndpoint);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const deleteTreatmentActivity = createAsyncThunk(
  "deleteTreatmentActivity",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(apiEndpoint);
      // Toaster.success(response?.data?.message);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getDashboardStats = createAsyncThunk(
  "getDashboardStats",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const searchPMSPatients = createAsyncThunk(
  "searchPMSPatients",
  async (data) => {
    try {
      const response = await axiosInstance.get(data.apiEndpoint);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const importPMSTreatments = createAsyncThunk(
  "importPMSTreatments",
  async (data) => {
    try {
      const response = await axiosInstance.post(data.apiEndpoint);
      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "Something went wrong";
    }
  }
);

export const getPendingPatients = createAsyncThunk(
  "getPendingPatients",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getRecentPatients = createAsyncThunk(
  "getRecentPatients",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const importPatientAndSyncTreatments = createAsyncThunk(
  "doctor/importPatientAndSyncTreatments",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(data.apiEndpoint);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPatientAppointments = createAsyncThunk(
  "getPatientAppointments",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const getAppointmentRequests = createAsyncThunk(
  "getAppointmentRequests",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response.status });
    }
  }
);

export const addAppointmentRequestCallbackLog = createAsyncThunk(
  "addAppointmentRequestCallbackLog",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData || {});
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.data?.message || error?.response?.data?.message);
      return thunkAPI.rejectWithValue({ statusCode: error.response?.status });
    }
  }
);

// Treatment plan (TxPlan) CRUD
export const getTxPlanList = createAsyncThunk(
  "getTxPlanList",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to load treatment plans");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const getPmsTransactions = createAsyncThunk(
  "getPmsTransactions",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to load transactions");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const getPmsNotes = createAsyncThunk(
  "getPmsNotes",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to load notes");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const getTxPlanOne = createAsyncThunk(
  "getTxPlanOne",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to load treatment plan");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const createTxPlan = createAsyncThunk(
  "createTxPlan",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData || {});
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to create treatment plan");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const updateTxPlan = createAsyncThunk(
  "updateTxPlan",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(apiEndpoint, requestData || {});
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to update treatment plan");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const deleteTxPlan = createAsyncThunk(
  "deleteTxPlan",
  async ({ apiEndpoint }, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(apiEndpoint);
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Failed to delete treatment plan");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);

export const suggestTxPlan = createAsyncThunk(
  "suggestTxPlan",
  async ({ apiEndpoint, requestData }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(apiEndpoint, requestData || {});
      return response?.data?.data;
    } catch (error) {
      Toaster.error(error?.response?.data?.message || "Could not generate suggestion; try again or build the plan manually.");
      return thunkAPI.rejectWithValue({ statusCode: error?.response?.status });
    }
  }
);
